import { NvSelectDropdown } from '@simwood/nv-react-components-v2';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nvFetch } from '../helpers/nvFetch';
import { setCallerId } from '../reducers/client';
import styles from '../styles/callerIdPicker.scss';
const CallerIdPicker = () => {
    const dispatch = useDispatch();
    const activeCustomerId = useSelector((state) => { var _a; return (_a = state.client.activeCustomer) === null || _a === void 0 ? void 0 : _a.id; });
    const defaultCallerId = useSelector((state) => { var _a; return (_a = state.extension.extension) === null || _a === void 0 ? void 0 : _a.defaultCallerId; });
    const selectedCallerId = useSelector((state) => state.client.selectedCallerId);
    const [outgoingCallerIds, setOutgoingCallerIds] = useState([]);
    const doSetCallerId = (callerIdId) => {
        const callerId = outgoingCallerIds.find((c) => c.id === callerIdId);
        if (!callerId) {
            return;
        }
        dispatch(setCallerId(callerId));
    };
    const callerIds = outgoingCallerIds.map((x) => ({
        value: x.id,
        label: x.number,
    }));
    useEffect(() => {
        // FIXME
        nvFetch(`/customers/${activeCustomerId}/outgoingcallerids`, {
            params: {
                pageSize: 200,
            },
        })
            .then((res) => res.json())
            .then((data) => {
            if (data.items) {
                setOutgoingCallerIds(data.items);
                if (!(selectedCallerId === null || selectedCallerId === void 0 ? void 0 : selectedCallerId.id) && defaultCallerId) {
                    const initialCallerId = data.items.find((x) => x.id === defaultCallerId);
                    if (initialCallerId) {
                        dispatch(setCallerId(initialCallerId));
                    }
                }
            }
        });
    }, []);
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.text_container },
            React.createElement("span", { className: styles.text_black }, "Calling from:"),
            React.createElement(NvSelectDropdown, { type: 'inline', color: {
                    text: 'var(--primary)',
                }, isClearable: false, isSearchable: false, className: styles.dropdown, options: callerIds, value: (selectedCallerId && selectedCallerId.number) || 'Anonymous', onChange: (selected) => {
                    doSetCallerId(selected[0].value);
                }, menuAlign: 'right', selectStyles: {
                    menu: (base) => (Object.assign(Object.assign({}, base), { width: 'max-content' })),
                    dropdownIndicator: (base) => (Object.assign(Object.assign({}, base), { color: 'var(--primary)' })),
                } }))));
};
export default CallerIdPicker;
